import { SystemCylinderConfiguration } from "@secureo/common/typings/Product"

const useSystemsConfiguration = (
	systems: SystemCylinderConfiguration[],
	selectedSystem: string,
	onSystemChange: (selectedSystem: string) => void,
) => {
	const systemInputProps = {
		value: selectedSystem,
		onChange: (selectedSystem: string) => {
			onSystemChange(selectedSystem)
		},
	}

	return {
		systemInputProps,
		availableSystem: systems,
	}
}

export default useSystemsConfiguration
